module.exports = __webpack_public_path__ + "img/Monte_Kope_30.36e746c3.jpg";